/* ============================================================
   Kaizen Seven — EFW PDP "Key Ingredients" ledger
   Mobile (<900px): dropdown accordion — first ingredient open,
   tapping a row header toggles it. Desktop: the full ledger is
   always visible and the headers are inert (display: contents).
   With JS off, mobile rows all render open (is-open only styles
   the indicator; the collapse requires this script's setup).
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.efwIngInit) return;
    root.dataset.efwIngInit = '1';

    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-efw-ing-row]'));
    if (rows.length === 0) return;

    root.classList.add('efw-ing--js');
    var mqMobile = window.matchMedia('(max-width: 899.98px)');

    function setOpen(row, open) {
      row.classList.toggle('is-open', open);
      var btn = row.querySelector('[data-efw-ing-toggle]');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    rows.forEach(function (row, i) {
      var btn = row.querySelector('[data-efw-ing-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (!mqMobile.matches) return;
        setOpen(row, !row.classList.contains('is-open'));
      });
    });

    function setMode() {
      if (mqMobile.matches) {
        rows.forEach(function (row, i) {
          setOpen(row, i === 0);
          var btn = row.querySelector('[data-efw-ing-toggle]');
          if (btn) btn.tabIndex = 0;
        });
      } else {
        /* Desktop: everything visible, headers out of the tab order */
        rows.forEach(function (row) {
          setOpen(row, true);
          var btn = row.querySelector('[data-efw-ing-toggle]');
          if (btn) { btn.tabIndex = -1; btn.removeAttribute('aria-expanded'); }
        });
      }
    }
    setMode();
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', setMode);
    else if (mqMobile.addListener) mqMobile.addListener(setMode);
  }

  function initAll() {
    document.querySelectorAll('[data-efw-ing]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init inside the Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-efw-ing]');
    if (root) init(root);
  });

  // Theme editor: open the block selected in the sidebar
  document.addEventListener('shopify:block:select', function (e) {
    var row = e.target && e.target.closest ? e.target.closest('[data-efw-ing-row]') : null;
    if (row && !row.classList.contains('is-open')) {
      row.classList.add('is-open');
      var btn = row.querySelector('[data-efw-ing-toggle]');
      if (btn && btn.hasAttribute('aria-expanded')) btn.setAttribute('aria-expanded', 'true');
    }
  });
})();
